export default __webpack_public_path__ + "static/media/1982.706dc96e.png";